import { Card, Divider, Typography } from '@mui/material';
import styled from 'styled-components';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import InfoCard from './InfoCard';
import { distanceStringMeterToKm, secondsToTimestamp } from '@/commons/utils';
import { useEffect, useState } from 'react';

const MainWrap = styled.div`
  width: 100%;
  min-width: 25rem;
  max-height: 8rem;
  min-height: 8rem;
  display: flex;
  flex-direction: column;
`;

const ContentBox = styled(Card)`
  width: 100%;
  height: 100%;
  background : #f5f5f5;
  margin-top: 0.25rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
`;

export default function CommonShippingBasicInfo({ info }: { info: any }) {
  return (
    <MainWrap>
      <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
        <LocalShippingIcon fontSize="large" sx={{ color: info?.color }} />
        <Typography variant="h5">{info?.car.name}</Typography>
      </div>
      <ContentBox>
        <InfoCard title="배송지" desc={info?.destLength} />
        <Divider orientation="vertical" variant="middle" flexItem />
        <InfoCard title="주문" desc={info?.orderLength} />
        <Divider orientation="vertical" variant="middle" flexItem />
        <InfoCard title="거리" desc={distanceStringMeterToKm(info?.distance)} />
        <Divider orientation="vertical" variant="middle" flexItem />
        <InfoCard title="시간" desc={secondsToTimestamp(info?.time)} />
      </ContentBox>
    </MainWrap>
  );
}
